import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import * as React from 'react';
import classNames from 'classnames';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';

var Col = function Col(props) {
  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


  var _getCompProps = getCompProps('Col', userDefaultProps, props),
      xs = _getCompProps.xs,
      sm = _getCompProps.sm,
      md = _getCompProps.md,
      lg = _getCompProps.lg,
      xl = _getCompProps.xl,
      flex = _getCompProps.flex,
      span = _getCompProps.span,
      pull = _getCompProps.pull,
      push = _getCompProps.push,
      style = _getCompProps.style,
      order = _getCompProps.order,
      offset = _getCompProps.offset,
      winWidth = _getCompProps.winWidth,
      children = _getCompProps.children,
      className = _getCompProps.className,
      customPrefixcls = _getCompProps.prefixCls; // className前缀


  var prefixCls = getPrefixCls(pkgPrefixCls, 'col', customPrefixcls);
  var columns = 24;
  var base = {
    span: span,
    pull: pull,
    push: push,
    offset: offset,
    order: order
  };

  if (xs && winWidth > 0) {
    if (xs.constructor === Number) base.span = xs;
    if (xs.constructor === Object) base = _extends(_extends({}, base), xs);
  }

  if (sm && winWidth >= 600) {
    if (sm.constructor === Number) base.span = sm;
    if (sm.constructor === Object) base = _extends(_extends({}, base), sm);
  }

  if (md && winWidth >= 1024) {
    if (md.constructor === Number) base.span = md;
    if (md.constructor === Object) base = _extends(_extends({}, base), md);
  }

  if (lg && winWidth >= 1280) {
    if (lg.constructor === Number) base.span = lg;
    if (lg.constructor === Object) base = _extends(_extends({}, base), lg);
  }

  if (xl && winWidth >= 1920) {
    if (xl.constructor === Number) base.span = xl;
    if (xl.constructor === Object) base = _extends(_extends({}, base), xl);
  }

  var width = base.span ? base.span / columns * 100 + '%' : '100%';
  var flexstr = "0 0 ".concat(width);

  if (flex) {
    if (flex.constructor === Number) {
      var _context;

      flexstr = _concatInstanceProperty(_context = "".concat(flex, " ")).call(_context, flex, " auto");
    }

    if (flex.constructor === String) {
      var flexArr = flex.split(' ');

      if (flexArr.length === 1 && /px/.test(flexArr[0])) {
        flexstr = "0 0 ".concat(flexArr[0]);
      } else {
        flexstr = flex;
      }
    }
  }

  var styleString = _extends({
    flex: flexstr,
    maxWidth: width,
    order: base.order,
    left: base.push && base.push / columns * 100 + '%',
    right: base.pull && base.pull / columns * 100 + '%',
    marginLeft: base.offset && base.offset / columns * 100 + '%'
  }, style);

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(prefixCls, className),
    style: styleString
  }, children);
};

Col.displayName = 'Col';
export default Col;